export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const SET_SUBSCRIPTIONS_FETCHING_STATUS =
  "SET_SUBSCRIPTIONS_FETCHING_STATUS";

export const FAILED = "FAILED";
export const FETCHING = "FETCHING";
export const SUCCESS = "SUCCESS";
